<template>
  <div class="message">
    <h3 class="activeR">个人信息</h3>
    <div class="photo_box">
      <PhotoCpn v-if="AUTH_OBJ.photo" :AUTH_OBJ="AUTH_OBJ" :token="token" />
    </div>

    <ul>
      <li>
        <el-divider></el-divider>
        <div class="message_item">
          <div>
            <b style="width: 20%">用户名</b>
            <el-link style="width: 60%" :underline="false" type="info">{{
              AUTH_OBJ.user_name
            }}</el-link>
          </div>
          <el-link
            type="primary"
            :underline="false"
            @click="centerDialogVisible1 = true"
            >修改</el-link
          >
        </div>
      </li>
      <li>
        <el-divider></el-divider>
        <div class="message_item">
          <div>
            <b style="width: 20%">手机</b>
            <el-link style="width: 60%" :underline="false" type="info">{{
              AUTH_OBJ.mobile
            }}</el-link>
          </div>
          <el-link
            type="primary"
            :underline="false"
            @click="fnLoginAndRegistration('mobile_change_confirm')"
            >换绑</el-link
          >
        </div>
      </li>
      <li>
        <el-divider></el-divider>
        <div class="message_item">
          <div>
            <b style="width: 20%">修改密码</b>
            <el-link style="width: 60%" :underline="false" type="info"
              >长度8-16， 必须字母开头，且包含数字</el-link
            >
          </div>
          <el-link
            type="primary"
            :underline="false"
            @click="fnLoginAndRegistration('set_password')"
            >设置</el-link
          >
        </div>
      </li>
      <li>
        <el-divider></el-divider>
        <div class="message_item">
          <div>
            <b style="width: 20%">注册时间</b>
            <el-link style="width: 60%" :underline="false" type="info">{{
              AUTH_OBJ.date_joined
            }}</el-link>
          </div>
          <el-tooltip
            effect="light"
            placement="top"
            :offset="10"
            trigger="hover"
          >
            <template #content>
              <p v-for="(item, index) in AUTH_OBJ.login_date_list" :key="index">
                <b>{{ item.login_type == 1 ? '密码登录' : '手机登录' }}</b
                >{{ item.login_date }}
              </p>
            </template>
            <el-link type="primary" :underline="false">查看最近登录</el-link>
          </el-tooltip>
        </div>
      </li>
      <li>
        <el-divider></el-divider>
        <div class="message_item">
          <div>
            <b style="width: 20%">真实姓名、银行卡</b>
            <el-link style="width: 60%" :underline="false" type="info"
              >认证后有利于账号安全，用于提款，开户姓名必须和真实姓名一致</el-link
            >
          </div>
          <el-link type="primary" :underline="false">管理</el-link>
        </div>
      </li>
      <li>
        <el-divider></el-divider>
        <div class="message_item">
          <div>
            <b style="width: 20%">账户注销</b>
            <el-link
              style="width: 60%"
              :underline="false"
              type="info"
            ></el-link>
          </div>
          <el-link type="primary" :underline="false">注销</el-link>
        </div>
        <el-divider></el-divider>
      </li>
    </ul>
    <!-- 修改密码 -->
    <el-dialog
      v-model="centerDialogVisible"
      width="400px"
      center
      :destroy-on-close="true"
    >
      <LogInToRegister :active_s="active_s" :AUTH_OBJ="AUTH_OBJ" />
    </el-dialog>
    <!-- 修改名称 -->
    <el-dialog
      v-model="centerDialogVisible1"
      width="400px"
      center
      :destroy-on-close="true"
    >
      <h4 style="color: #f56c6c; margin: 10px 0">请输入名字</h4>
      <el-input
        v-model="user_name"
        maxlength="16"
        placeholder="请输入名字"
        show-word-limit
        type="text"
      />
      <el-button size="small" type="primary" @click="user_name_fn">
        确认修改</el-button
      >
    </el-dialog>
  </div>
</template>
<script>
import { ref, getCurrentInstance, inject } from 'vue'
import PhotoCpn from './cpn/photo_cpn.vue'
import LogInToRegister from '../LogInToRegister.vue'
export default {
  props: ['AUTH_OBJ', 'token'],
  components: {
    PhotoCpn,
    LogInToRegister
  },
  setup() {
    let { proxy: _this } = getCurrentInstance()
    // 修改密码
    let centerDialogVisible = ref(false)
    let centerDialogVisible1 = ref(false)
    let active_s = ref('')
    let fnLoginAndRegistration = (v) => {
      centerDialogVisible.value = true
      active_s.value = v
    }
    // 修改名字
    let qs = require('qs')
    // 刷新
    const refresh = inject('reload')
    let user_name = ref('')
    let user_name_fn = async () => {
      if (!user_name.value) {
        return _this.$notify({
          title: '提示',
          message: '名字不能为空',
          type: 'error'
        })
      }
      let { data: res } = await _this.$http.put(
        '/auth/user/set_username',
        qs.stringify({
          user_name: user_name.value
        })
      )
      if (res.code == 200) {
        _this.$notify({
          title: '提示',
          message: res.message,
          type: 'warning'
        })
        refresh()
      } else {
        _this.$notify({
          title: '提示',
          message: res.message,
          type: 'error'
        })
      }
    }
    return {
      fnLoginAndRegistration,
      active_s,
      centerDialogVisible,
      centerDialogVisible1,
      user_name,
      user_name_fn
    }
  }
}
</script>
<style lang="less">
.message {
  h3 {
    font-weight: 600;
  }
  .el-dialog__body {
    background: url('../../../assets/footballBg.jpg') no-repeat 100%;
    background-size: cover;
  }
  .el-dialog__header {
    color: #fff;
    .el-icon-close {
      position: absolute;
      z-index: 999;
      color: #fff;
      top: 10px;
      right: 10px;
    }
  }
  .el-dialog__body {
    margin-top: -30px;
  }
  .el-input__inner {
    background-color: rgba(0, 0, 0, 0.3);
    color: #fff;
  }
}
</style>
<style scoped lang="less">
.message {
  .photo_box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ul {
    li {
      .message_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        div {
          display: flex;
          width: 50%;
          align-items: center;
          justify-content: space-between;
          b {
            width: 20%;
            color: #666;
            font-size: 14px;
          }
          .el-link {
            display: flex;
            justify-content: flex-start;
          }
        }
      }
    }
  }
}

// ----------
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
